const securus_shop_id = 'boutique-sha-online';
const aws_api_url = 'https://lieu4v8w5f.execute-api.ap-northeast-1.amazonaws.com/prod/api/';

/*
function securusBookendStart() {
  try {
    BEObj.setOption({
      ins_app_name: "★カスタムアプリ名",
      url_ins_ios : "https://apps.apple.com/jp/app/★/idXXXXXXXXXX?itsct=apps_box&itscg=30200",
      url_ins_and : "https://play.google.com/store/apps/details?id=jp.★.app",
      url_ins_win : "★Windows版アプリのダウンロードURL(bookend契約内容により中継サーバ or bookendサーバとなる)",
      url_ins_mac : "★Mac版アプリのダウンロードURL(bookend契約内容により中継サーバ or bookendサーバとなる)",
    });
    
    BEObj.startBookendClient({
      CustomScheme:true,
      CustomName : "bookend",
      UniversalLink :true
    });
  } catch(e) {
    alert(e.message);
  }
}
*/
/*
function securusCheckSubscStatus(id){
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/subscription_status',
    data : { customer_id : id },
    dataType    : "json",
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log('subscription_status: ' + data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log('subscription_status: ' + data.error);
      return;
    }
    if( data ){
      if( data.result < 1 ){
        $('#div_subsc_warning').show();
      }
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}
*/

function securusCheckShowBeBut(id)
{
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/is_show_be_but',
    data : { customer_id : id },
    dataType : "json",
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log('is_show_be_but: ' + data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log('is_show_be_but: ' + data.error);
      return;
    }
    if( data ){
      console.log('is_show_be_but: ' + data.result);
      if( data.result ){
        $('#but-beapp').show();
      }
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}

function securusCheckShowLibraryBut(id)
{
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/is_show_library_but',
    data : { shop : securus_shop_id, customer_id : id },
    dataType    : "json",      
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log('is_show_library_but: ' + data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log('is_show_library_but: ' + data.error);
      return;
    }
    if( data ){
      console.log('is_show_library_but: ' + data.result);
      if( data.result ){
        $('#but-view-library').show();
      }
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}

function securusCheckShowLibrarySearchBut(id, shop)
{
  $.ajax(aws_api_url + 'subscription-contract-unlimited-disp?shop=' + shop + '&customer-id=' + id)
  .done(function(res){
    console.log('subscription-contract-unlimited-disp: ' + res);
    if(res === true){
      $('#but-view-library-search').show();
    }
  }).fail(function() {
    console.error('読み放題ボタン表示判定取得処理エラー');
  });
}

function securusCheckShowSubscCancelBut(id, shop)
{
  $.ajax(aws_api_url + 'subscription-cancel-disp?shop=' + shop + '&customer-id=' + id)
  .done(function(res){
    console.log('subscription-cancel-disp: ' + res);
    if(res === true){
      $("#subscription-cancel").css("display", "block");
    }
  }).fail(function() {
    console.error('解約ボタン表示判定取得処理エラー');
  });
}

function securusButViewLibraryClick()
{
  var url = 'https://' + securus_shop_id + '.securus.bz/my-library';
  var inputs = "<input type='hidden' name='customer_id' value='" + $(this).data('customerid') + "'>";
  $("body").append('<form action="'+url+'" method="post" id="post">'+inputs+'</form>');
  $("#post").submit();
  return false
}

function securusButViewLibrarySearchClick()
{
  var url = 'https://' + securus_shop_id + '.securus.bz/my-library-search';
  var inputs = "<input type='hidden' name='customer_id_search' value='" + $(this).data('customeridsearch') + "'>";
  $("body").append('<form action="'+url+'" method="post" id="post_search">'+inputs+'</form>');
  $("#post_search").submit();
}

function securusClickWebViewer(id, type)
{
  try {
    let params = {
      shop : securus_shop_id,
      contents_id: id,
    };
    if (type.toUpperCase() == 'PDF') endpoint = "viewer-pdf-brdg";
    if (type.toUpperCase() == 'EPUB') endpoint = "viewer-epub-brdg";
    window.open('', 'bookend_viewer_' + params.contents_id);
    $.ajax({
      type: 'post',
      url: 'https://' + securus_shop_id + '.securus.bz/api/' + endpoint,
      data: params,
      dataType: "json",
    }).done(function (data, textStatus) {
      if (data && data.errors) {
        alert('ビューアの起動に失敗しました\n' + data.errors.join('\n'));
        return;
      }
      if (data && data.error) {
        alert('ビューアの起動に失敗しました\n' + data.error);
        return;
      }
      if (data) {
        window.open(data.url, 'bookend_viewer_' + params.contents_id);
      }
    }).fail(function (data, textStatus, errorThrown) {
      if (errorThrown == 'Unauthorized') {
        alert('前回動作から時間が経ちましたので、ページを再読み込みしてください');
      } else {
        alert('通信エラーが発生しました');
      }
    });
  } catch(e) {
    alert(e.message);
  }
}
